import Cookies from "js-cookie";
import { authStore } from "@/pages/Login/store";
import { paths } from "@/navigation/paths";

export function logoutHandler() {
  try {
    Cookies.remove("token");
    Cookies.remove("refresh-token");
    authStore.getState().setLogout();
    window.location.replace(paths.LOGIN);
  } catch (err: unknown) {
    console.log("Something went wrong during logout", err);
  }
}
